import React from 'react';

import { useRoleShowState, useRoleShowActions } from './RoleShowContext';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { addRestrictedActionToRole } from './restApi';

const AddRestrictedActionForm = ({ role }) => {
  const state = useRoleShowState();
  const { onResponse, onError, updateNewRestrictedActionId, closeAddRestrictedActionModal } = useRoleShowActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    addRestrictedActionToRole({
      role,
      onResponse,
      onError,
      body: {
        newRestrictedAction: state?.newRestrictedAction,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Restricted Action ID" id="restrictedActionId">
        <Input
          type="text"
          value={state?.newRestrictedAction?.id || ''}
          onChange={(e) => {
            updateNewRestrictedActionId(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeAddRestrictedActionModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Add Restricted Action
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default AddRestrictedActionForm;
